import { useQuery } from "@apollo/client"
import { MenuItem } from "@blueprintjs/core"
import { get } from "lodash-es"
import React from "react"
import { useDispatch, useSelector } from "react-redux"
import CustomButton from "components/Atoms/CustomButton"
import DynamicSelector from "components/Molecules/DynamicSelector"
import { DISPATCH_VEHICLES } from "graphql/dispatch/dispatch.queries.gql"
import { USERS } from "graphql/selector.queries.gql"
import { CHANGE_DISPATCH_VEHICLE } from "store/dispatch.redux"
import { getId } from "utils/custom.utils"
const VehicleSelector = ({ onBackClick = undefined }) => {
  const { data } = useQuery(USERS, { variables: { group: "Aggregator" } })
  const aggregators = data?.usersByGroup

  const value = useSelector((state: any) => state.dispatch.vehicle)

  const dispatch = useDispatch()
  return (
    <div className="flex justify-start">
      {onBackClick && (
        <CustomButton icon="arrow-left" minimal onClick={onBackClick} />
      )}

      <DynamicSelector
        label="Vehicle"
        inline
        className="ml-1 mb-0"
        searchVector={["registrationNumber"]}
        name={["registrationNumber"]}
        value={value}
        query={DISPATCH_VEHICLES}
        onChange={(_, value) => {
          const aggregator = aggregators?.find(
            a => getId(a) === getId(value.driver)
          )
          dispatch({
            type: CHANGE_DISPATCH_VEHICLE,
            payload: value,
            aggregator: aggregator,
          })
        }}
        itemRenderer={(item, { handleClick, modifiers }) => {
          return (
            <MenuItem
              labelElement={
                <span>
                  {`${get(item, "vehicleType.name")}, `}
                  <span className="vt-highlight">
                    {item?.vehicleType?.capacity}{" "}
                  </span>
                  {`${get(item, "vehicleType.capacityUnit.codename")}`}
                </span>
              }
              icon="drive-time"
              active={modifiers.active}
              key={item?.id}
              onClick={handleClick}
              text={item.registrationNumber}
            />
          )
        }}
      />
    </div>
  )
}

export default VehicleSelector
